import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import AgreementSettings from '../../common/AgreementSettings';
import AgreementAcceptances from '../../common/AgreementAcceptances';
const t = key => app.translator.trans('ppk2-profile.lib.agreement.' + key);

/** /agreement-settings: «Пользовательское соглашение» settings + acceptances (admins, «Техподдержка»). */
export default class AgreementSettingsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('ppk2CanViewAccountLog')) {
      m.route.set(app.route('index'));
      return;
    }
    app.setTitle(t('settings_title'));
  }
  view() {
    if (!app.forum.attribute('ppk2CanViewAccountLog')) return m("div", null);
    return m("div", {
      className: "Ppk2AccountLogPage Ppk2AgreementSettingsPage"
    }, m("div", {
      className: "container"
    }, m("h2", null, t('settings_title')), m(AgreementSettings, null), m("h3", null, t('acceptances')), m(AgreementAcceptances, null)));
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/AgreementSettingsPage', AgreementSettingsPage);